/** Date Functions Ends */

import { responseDataFormate } from "./bycrypt";

// Define a type for the dispatch function
type Dispatch = (action: { type: string; payload: { scope: string; status?: boolean | string | string[] } }) => void;

// Error Handling Functions
export const dispatchLoading = (dispatch: Dispatch, scope: string, status: boolean) =>
  dispatch({ type: "SET_LOADING", payload: { scope, status } });

export const dispatchToast = (dispatch: Dispatch, scope: string, status: boolean | string) =>
  dispatch({ type: "SET_TOAST", payload: { scope, status } });

export const dispatchError = (dispatch: Dispatch, scope: string, status: string[] | string | undefined) =>
  dispatch({ type: "SET_ERROR", payload: { scope, status } });

interface Data {
  message: string;
  error: string;
}
// export const catchHandler = (dispatch: Dispatch, scope: Scope) => (err: AxiosErrorResponse) => {
export const catchHandler = (dispatch: Dispatch, scope: any) => (error: any) => {
  let err = error;
  if (err?.code == "ERR_CANCELED") {
    return;
  }
  console.log(error, "errorerror");
  let errorData = responseDataFormate(err?.response?.data);
  const errMsg = errorData?.msg || errorData?.message || errorData?.error || "Something went wrong";

  dispatchToast(dispatch, "error", errMsg);

  if (err.code === "ERR_NETWORK") {
    dispatchToast(dispatch, "error", "Unable to connect to server");
  } else if (err?.response?.status !== 401) {
    dispatchError(dispatch, scope, [errMsg]);
  } else if (err?.response?.status === 401) {
    localStorage.setItem("isLoggedIn", "false");
    dispatchError(dispatch, scope, [errMsg]);
    // window.location.assign(`${CLIENT_URL}/auth/login`);
  } else {
    dispatchToast(dispatch, "error", errMsg);
  }

  dispatchLoading(dispatch, scope, false);
  dispatchError(dispatch, scope, [errMsg]);
};

export const elseHandler = (dispatch: Dispatch, scope: string, data: Data) => {
  dispatchToast(dispatch, "error", data?.message);
  dispatchError(dispatch, scope, data?.error);
};
export const Reset = () => {
  localStorage.removeItem("userAccessToken");
};
